export default function Banner() {
  return (
    <section className="relative overflow-hidden bg-primary-800">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <div className="absolute -left-24 top-0 h-64 w-64 rounded-full bg-secondary-400 blur-3xl"></div>
        <div className="absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-accent-500 blur-3xl"></div>
      </div>
      <div className="relative mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-6 px-4 py-12 text-center md:flex-row md:px-6 md:py-14 md:text-left">
        <div className="flex items-center gap-4">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-trophy-line text-2xl"></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
              Ask how we retain our clients 3x longer than the industry average
            </h2>
            <p className="mt-1 text-sm text-secondary-200">
              Trusted by HOAs, offices, medical facilities and resorts across Southwest Florida.
            </p>
          </div>
        </div>
        <a
          href="#quote"
          className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-800 transition-colors hover:bg-accent-500 hover:text-background-50"
        >
          Talk To Our Team <i className="ri-arrow-right-line text-[18px]"></i>
        </a>
      </div>
    </section>
  );
}